import React from "react";
import { Link } from "react-router-dom";

import styles from "./TableLink.module.scss";

export function TableLink({ href, children, openInNewTab = false }) {
  const newTabProps = openInNewTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <Link to={href} className={styles.link} {...newTabProps}>
      {children}
    </Link>
  );
}
